import React from "react";

interface GridProps {
  children?: React.ReactNode;
  itemsPerRow?: number;
  gap?: number;
  testID?: string;
}

/**
 * Displays 2D array of components.
 */
export function Grid(props: GridProps) {
  const { children, itemsPerRow = 1, testID, gap = 0 } = props;
  const flexBasis = `${(1 / itemsPerRow) * 100}%`;

  return (
    <div
      data-component="Grid"
      data-testid={testID}
      style={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {React.Children.map(children, (child, index) => {
        // const excludeGap = index !== 0 && (index + 1) % itemsPerRow === 0;

        return (
          <div
            style={{
              width: flexBasis,
            }}
          >
            <div
              style={{
                paddingRight: gap,
                paddingBottom: gap,
                height: "100%",
              }}
            >
              {child}
            </div>
          </div>
        );
      })}
    </div>
  );
}
